import {isOfficialInformationTouched} from "./helper";

export const STEP_GENERAL_INFORMATION = 'generalInformation';
export const STEP_SERVICE_MOBILITY = 'serviceMobility';
export const STEP_DATE_RECEPTION = 'dateReception';
export const STEP_PERSONAL_INFORMATION = 'personalInformation';
export const STEP_SUMMARY = 'summary';

export const DRIVE_IN_ON_REQUEST = 'ON_REQUEST';
export const DRIVE_IN_MANDATORY = 'MANDATORY';
export const STANDARD_RECEPTION = 'standard';
export const DRIVE_IN_RECEPTION = 'driveIn';
export const FASTLANE_RECEPTION = 'fastlane';

export const NO_MOBILITY = 'no';
export const ROAD_ASSIST_MOBILITY = 'road_assist';
export const OWN_MOBILITY = 'own';
export const WAIT_MOBILITY = 'wait';
export const HOME_SERVICE_MOBILITY = 'homeService';

export const TIRES_EXCHANGE = 'tiresExchange';
export const TIRE_REPLACEMENT = 'tiresReplacement';

export const TIRE_TYPE_SUMMER = 'SUMMER';
export const TIRE_TYPE_WINTER = 'WINTER';
export const TYPE_WHEELS = 'WHEELS';
export const TYPE_TIRES = 'TIRES';
export const TYPE_IDK = 'IDK';
export const MODE_BRING = 'BRING';
export const MODE_DONT_BRING = 'DONT_BRING';
export const MODE_IDK = 'IDK';
// responsive size class
export const SIZE_CLASS_XS = 'xs';
export const SIZE_CLASS_SM = 'sm';
export const SIZE_CLASS_MD = 'md';
export const SIZE_CLASS_LG = 'lg';
export const SIZE_CLASS_XL = 'XL';
export const SIZE_CLASS_XXL = 'XXL';

export const MAINTENANCE = 'maintenance';
export const TIRES = 'tires';
export const BODY_REPAIR = 'body';

export const APPOINTMENT_TYPE_URL_NAME = {
  [MAINTENANCE]: 'appointment',
  [TIRES]: 'tires-wheels',
  [BODY_REPAIR]: 'bodyshop'
}

export const SERVICE_PIT_STOP_TIRES = 'pit-stop-tires';
export const SERVICE_PIT_STOP_WHEELS = 'pit-stop-wheels';

export const DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const STEPS_JOURNEY_WITH_RENTAL = [
  STEP_GENERAL_INFORMATION,
  STEP_SERVICE_MOBILITY,
  STEP_DATE_RECEPTION,
  STEP_PERSONAL_INFORMATION,
  STEP_SUMMARY,
];
export const STEPS_JOURNEY = [
  STEP_GENERAL_INFORMATION,
  STEP_SERVICE_MOBILITY,
  STEP_DATE_RECEPTION,
  STEP_PERSONAL_INFORMATION,
  STEP_SUMMARY,
];
export function getMaintenanceRepairStepStatus(step, currentStep, steps) {
  if (step === currentStep) return 'process';
  const slicedSteps = steps.slice(0, currentStep);
  if (slicedSteps.includes(steps[step])) return 'finish';
  return 'wait';
}

export function isNextDisabled(currentStep, state, vehicleVIN, customerPreJourneyInfo, createAppointmentRequest, publicContext) {
  if (currentStep === STEP_GENERAL_INFORMATION) {
    const { generalInformation } = createAppointmentRequest;
    if (vehicleVIN) {
      return (
        !parseInt(generalInformation.mileage, 10) ||
        !generalInformation.plateNumber || generalInformation.plateNumber.trim() === '' ||
        !generalInformation.phoneNumber || generalInformation.phoneNumber.trim() === '' ||
        !generalInformation.vinVehicleModel || generalInformation.vinVehicleModel.trim() === ''
      );
    }
    return !parseInt(generalInformation.mileage, 10) ||
      !generalInformation.plateNumber || generalInformation.plateNumber.trim() === '' ||
      !generalInformation.phoneNumber || generalInformation.phoneNumber.trim() === '';
  }
  if (currentStep === STEP_SERVICE_MOBILITY) {
    if (customerPreJourneyInfo.type === TIRES) {
      const tireExchangeIndex = createAppointmentRequest.selectedOptions.findIndex(
        option => option.id === TIRES_EXCHANGE
      );
      if (tireExchangeIndex != -1) {
        return createAppointmentRequest.selectedOptions.length == 0 ||
          !createAppointmentRequest.chosenMobility ||
          !createAppointmentRequest.tiresExchange ||
          !createAppointmentRequest.tiresExchange.type ||
          !createAppointmentRequest.tiresExchange.mode;
      }
      return createAppointmentRequest.selectedOptions.length == 0 ||
        !createAppointmentRequest.tiresExchange ||
        !createAppointmentRequest.tiresExchange.type ||
        !createAppointmentRequest.tiresExchange.mode;
    }
    const tireExchangeIndex = createAppointmentRequest.selectedOptions.findIndex(
      option => option.id === TIRES_EXCHANGE
    );
    if (tireExchangeIndex != -1 && createAppointmentRequest.tiresExchange) {
      return !(
        createAppointmentRequest.selectedOptions.length > 0 &&
        createAppointmentRequest.chosenMobility &&
        createAppointmentRequest.tiresExchange.type &&
        createAppointmentRequest.tiresExchange.mode
      );
    }
    const tireReplacementIndex = createAppointmentRequest.selectedOptions.findIndex(
      option => option.id === TIRE_REPLACEMENT
    );
    if (tireReplacementIndex != -1) {
      const {tireReplacement} = createAppointmentRequest
      return !tireReplacement || !(
        createAppointmentRequest.selectedOptions.length > 0 &&
        createAppointmentRequest.chosenMobility &&
        (tireReplacement.selectedFrontLeftTire ||
          tireReplacement.selectedFrontRightTire ||
          tireReplacement.selectedBackLeftTire ||
          tireReplacement.selectedBackRightTire) &&
        tireReplacement.selectedTireType
      );
    }
    //if (publicContext.bookingToken ){
    //  return false;
    //}
    return !((publicContext.bookingToken || createAppointmentRequest.selectedOptions.length > 0) && createAppointmentRequest.chosenMobility);
  }
  if (currentStep === STEP_DATE_RECEPTION) {
    if (customerPreJourneyInfo.type === TIRES) {
      return !(state.selectedDate && state.selectedSlot);
    }
    return !(state.selectedDate && state.selectedSlot && state.reception);
  }
  if (currentStep === STEP_PERSONAL_INFORMATION) {
    // address side
    const incompleteAddress = !state.number || state.number.trim() === '' ||
      !state.street || state.street.trim() === '' ||
      !state.zipCode || state.zipCode.trim() === '' ||
      !state.city || state.city.trim() === '' ||
      !state.country || state.country.trim() === '';
    if (incompleteAddress){
      return true;
    }

    // personal information side
    if (createAppointmentRequest.chosenMobility && isMobilityRental(createAppointmentRequest.chosenMobility.mobilityOption, customerPreJourneyInfo.mobility.categoryMobility) && isOfficialInformationTouched(state)) {
      return !(
        state.licenseId &&
        state.licenseId.length > 0 &&
        state.licenseDeliveryDate &&
        state.idCardNumber &&
        state.idCardNumber.length > 0 &&
        state.birthDate &&
        state.nationality &&
        state.nationality.length > 0 &&
        state.validity
      );
    }
    return false;
  }
}

export function isMobilityRental(mobility, categoryMobility) {
  return mobility === 'motorbike' || categoryMobility.filter(m => m.name === mobility).length > 0;
}

export function canCome247WithRental(selectedDealer) {
  return (
    !!selectedDealer.capabilities['rental-pickup'] &&
    !!selectedDealer.capabilities['car-drop-off']
  );
}

export function canCome247WithoutRental(selectedRental) {
  return !!selectedRental.capabilities['car-drop-off'];
}



// WEBPACK FOOTER //
// ./src/public/journey1/definition/business.js